import { Outlet } from 'react-router-dom'

export const handle = {
  title: `Availability`,
  breadcrumb: `Availability`,
}

export default function AvailabilityLayout(): React.ReactElement {
  return <Outlet />
}
